import { Database, ChevronRight, Timer, BookOpen } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { usePhaseTimesAvailable } from "@/hooks/useWorkflowDefinitions";

export default function CompanyDataManagement() {
  const navigate = useNavigate();
  const { t } = useTranslation("admin");
  const { available: phaseTimes } = usePhaseTimesAvailable();

  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="px-6 pt-8 pb-6">
        <div className="flex items-center gap-2 mb-1">
          <Database className="w-5 h-5 text-primary" />
          <h1 className="text-2xl font-bold text-foreground">Data Management</h1>
        </div>
        <p className="text-muted-foreground">Company-scoped data tools.</p>
      </div>

      <div className="px-6 space-y-6">
        {/* Phase Time Estimates */}
        {phaseTimes && <button
          onClick={() => navigate("/settings/data/phase-times")}
          className="w-full bg-card rounded-xl border border-border p-5 flex items-center gap-4 hover:bg-muted/50 transition-colors text-left"
        >
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <Timer className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1">
            <p className="font-medium text-foreground">{t("data.tiles.phaseTime.title")}</p>
            <p className="text-sm text-muted-foreground">{t("data.tiles.phaseTime.description")}</p>
          </div>
          <ChevronRight className="w-5 h-5 text-muted-foreground" />
        </button>}

        {/* Repair Guide Center */}
        <button
          onClick={() => navigate("/settings/data/repair-guides")}
          className="w-full bg-card rounded-xl border border-border p-5 flex items-center gap-4 hover:bg-muted/50 transition-colors text-left"
        >
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
            <BookOpen className="w-5 h-5 text-primary" />
          </div>
          <div className="flex-1">
            <p className="font-medium text-foreground">{t("data.tiles.manuals.title")}</p>
            <p className="text-sm text-muted-foreground">{t("data.tiles.manuals.description")}</p>
          </div>
          <ChevronRight className="w-5 h-5 text-muted-foreground" />
        </button>
      </div>
    </div>
  );
}
